import ManageUsers from '../components/ManageUsers';
import ManageReports from '../components/ManageReports';
import ManageComapnies from "../components/ManageComapnies";
import ManageGroups from "../components/ManageGroups";
import ManagePaymentSuccess from '../components/ManagePaymentSuccess'
import Home from '../pages/Home';
import Report from '../pages/Report';
import { ProtectedRoute } from "./ProtectedRoute";
import ManagePayment from '../components/ManagePayment';
import ManageInvoiceLineItems from '../components/ManageInvoiceLineItems';
import Widget from '../pages/Widget';
import { PieChart, Pie, Legend, Tooltip, ResponsiveContainer, BarChart, Bar, CartesianGrid, XAxis, YAxis } from "recharts";
import ManageSecurityGroups from '../components/ManageSecurityGroups';

const data01 = [
  { name: "Group A", value: 400 },
  { name: "Group B", value: 300 },
  { name: "Group C", value: 300 },
  { name: "Group D", value: 200 },
  { name: "Group E", value: 278 },
  { name: "Group F", value: 189 }
];

const data02 = [
  { name: "Group A", value: 2400 },
  { name: "Group B", value: 4567 },
  { name: "Group C", value: 1398 },
  { name: "Group D", value: 9800 },
  { name: "Group E", value: 3908 },
  { name: "Group F", value: 4800 }
];
const data = [
  {
    name: 'Page A',
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: 'Page B',
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: 'Page C',
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: 'Page D',
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: 'Page E',
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: 'Page F',
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: 'Page G',
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];


const renderCustomizedLabel = (props) => {
  const { name, value } = props;
  return (
    <text {...props}>
      {`${name} ${value}`}
    </text>
  );
}

export const routes = [
  {
    path: "",
    element: <Home />,
  },
  {
    path: "report",
    children: [
      {
        path: ":type/:id",
        element: <Report />,
      },
    ],
  },
  {
    path: "widget",
    children: [
      {
        path: ":type/:id",
        element: <Widget />,
      },
    ],
  },
  {
    path: "/manageusers",
    element: (
      <ProtectedRoute>
        <ManageUsers />
      </ProtectedRoute>
    ),
  },
  {
    path: "/charts",
    element: (
      <>
        <ResponsiveContainer width="100%" height="100%">
          <div style={{ display: 'flex', justifyContent: 'space-between', margin: 8, alignItems: 'center' }}>
            <PieChart width={400} height={400}>      <Pie
              dataKey="value"
              isAnimationActive={false}
              data={data01}
              cx={200}
              cy={200}
              outerRadius={80}
              fill="#8884d8"
              label={renderCustomizedLabel}
            />  <Tooltip /></PieChart>

            <BarChart width={450} height={250} data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="pv" fill="#8884d8" />
              <Bar dataKey="uv" fill="#82ca9d" />
            </BarChart>
          </div>
        </ResponsiveContainer>
      </>
    ),
  },
  {
    path: "/managewidgets",
    element: (
      <ProtectedRoute>
        <ManageReports />
      </ProtectedRoute>
    ),
  },
  {
    path: "/managecompanies",
    element: (
      <ProtectedRoute>
        <ManageComapnies />
      </ProtectedRoute>
    ),
  },
  {
    path: "/managegroups",
    element: (
      <ProtectedRoute>
        <ManageGroups />
      </ProtectedRoute>
    ),
  },
  {
    path: "/managesecuritygroups",
    element: (
      <ProtectedRoute>
        <ManageSecurityGroups />
      </ProtectedRoute>
    ),
  },
  {
    path: "/paymentsuccess",
    element: (
      <ProtectedRoute>
        <ManagePaymentSuccess />
      </ProtectedRoute>
    ),
  },
  {
    path: "/invoicepayment",
    element: (
      <ProtectedRoute>
        <ManagePayment />
      </ProtectedRoute>
    ),
  },
  {
    path: "/invoiceitems/:id/:invoiceId",
    element: (
      <ProtectedRoute>
        <ManageInvoiceLineItems />
      </ProtectedRoute>
    ),
  },
  // {
  //   path: "/invpayment/:id/:invoiceId",
  //   element: (
  //     <ProtectedRoute>
  //       <ManagePayment isEmail />
  //     </ProtectedRoute>
  //   ),
  // },
];
